var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebCustomerIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16,16H0V14c0-1.506,1.625-2.47,2.988-3.013A14.72,14.72,0,0,1,8,10a14.72,14.72,0,0,1,5.013.988C14.376,11.531,16,12.494,16,14v2ZM8,8a4,4,0,1,1,4-4A4.005,4.005,0,0,1,8,8Z",
    fill: "#ff9800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebCustomerIconOrange);
export default __webpack_public_path__ + "static/media/Web_Customer_Icon_Orange.a245e0672ec06b995967ac4c0e373585.svg";
export { ForwardRef as ReactComponent };